import type {
  UserPreference,
  UserPreferencesResponse,
} from '@kirin/api-client/contracts/user-preferences';

/**
 * Merge a single `UserPreference` into a `UserPreferencesResponse`,
 * replacing an existing row with the same `key` or appending it when absent.
 * Pure data transform — safe to call from React Query updater callbacks.
 */
export function mergePreference(
  old: UserPreferencesResponse | undefined,
  updated: UserPreference
): UserPreferencesResponse {
  if (!old) {
    return { preferences: [updated] } as UserPreferencesResponse;
  }
  const replaced = old.preferences.map(p =>
    p.key === updated.key ? updated : p
  );
  // Append if key wasn't present (backend should always merge defaults).
  const merged = replaced.some(p => p.key === updated.key)
    ? replaced
    : [...replaced, updated];
  return { ...old, preferences: merged };
}
